<p-dialog
  header="Структура вхідної ціни"
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [style]="{'width': '640px', 'max-height': '80vh'}"
  (onHide)="onHide()">

  <ng-container *ngIf="mode === 'single'">
    <p-progressSpinner *ngIf="loading" styleClass="income-price-breakdown-dialog__spinner" strokeWidth="6"></p-progressSpinner>

    <div *ngIf="!loading && error" class="income-price-breakdown-dialog__error">
      Не вдалося завантажити структуру ціни. Спробуйте пізніше.
    </div>

    <div *ngIf="!loading && !error && rows.length === 0" class="income-price-breakdown-dialog__empty">
      Немає історії надходжень для цього товару на цю дату.
    </div>

    <div *ngIf="!loading && !error && isFallback" class="income-price-breakdown-dialog__fallback">
      На складі немає партій, що відповідають цій даті — використано ціну останнього надходження
      для всієї кількості (нижче).
    </div>

    <p-table *ngIf="!loading && !error && rows.length > 0" [value]="rows" styleClass="p-datatable-gridlines p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th>Документ</th>
          <th>Дата</th>
          <th style="text-align: right">Кількість</th>
          <th style="text-align: right">Ціна (валюта документа)</th>
          <th style="text-align: right">Сума (валюта документа)</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr>
          <td>{{row.DOCNUMBER}}</td>
          <td>{{row.DOCDATE | date:'dd.MM.yyyy'}}</td>
          <td style="text-align: right">{{row.UnitsFromBatch | number:'1.0-2'}}</td>
          <td style="text-align: right">{{row.ConvertedPrice | number:'1.2-2'}}</td>
          <td style="text-align: right">{{row.LineValue | number:'1.2-2'}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer">
        <tr class="income-price-breakdown-dialog__totals">
          <td colspan="2">Разом</td>
          <td style="text-align: right">{{totalUnits | number:'1.0-2'}}</td>
          <td style="text-align: right" [class.income-price-breakdown-dialog__mismatch]="isMismatch">
            {{weightedAvgPrice | number:'1.2-2'}}
          </td>
          <td style="text-align: right">{{totalValue | number:'1.2-2'}}</td>
        </tr>
      </ng-template>
    </p-table>

    <div *ngIf="!loading && !error && rows.length > 0" class="income-price-breakdown-dialog__compare">
      <div *ngIf="cellPriceCurrency !== null">
        Ціна в документі (валюта документа): <strong>{{cellPriceCurrency | number:'1.2-2'}}</strong>
        <span *ngIf="isMismatch" class="income-price-breakdown-dialog__mismatch-note">
          — не збігається з розрахованою вище
        </span>
        <span *ngIf="!isMismatch" class="income-price-breakdown-dialog__match-note">
          — збігається
        </span>
      </div>
      <div *ngIf="cellPriceMain !== null">
        Ціна в документі (основна валюта): <strong>{{cellPriceMain | number:'1.2-2'}}</strong>
        (розраховано: {{weightedAvgPriceMain | number:'1.2-2'}})
        <span *ngIf="isMismatchMain" class="income-price-breakdown-dialog__mismatch-note">
          — не збігається з розрахованою
        </span>
        <span *ngIf="!isMismatchMain" class="income-price-breakdown-dialog__match-note">
          — збігається
        </span>
      </div>
      <div *ngIf="storedPriceCurrency !== null" class="income-price-breakdown-dialog__stored-price">
        Зафіксована в документі ціна (валюта документа): <strong>{{storedPriceCurrency | number:'1.2-2'}}</strong>
        <span *ngIf="isStoredPriceMismatch" class="income-price-breakdown-dialog__mismatch-note">
          — не збігається з поточною відомою ціною ({{cellPriceCurrency | number:'1.2-2'}})
        </span>
        <span *ngIf="!isStoredPriceMismatch" class="income-price-breakdown-dialog__match-note">
          — збігається
        </span>
      </div>
      <div *ngIf="storedPriceMain !== null" class="income-price-breakdown-dialog__stored-price">
        Зафіксована в документі ціна (основна валюта): <strong>{{storedPriceMain | number:'1.2-2'}}</strong>
        <span *ngIf="isStoredPriceMismatchMain" class="income-price-breakdown-dialog__mismatch-note">
          — не збігається з поточною відомою ціною ({{cellPriceMain | number:'1.2-2'}})
        </span>
        <span *ngIf="!isStoredPriceMismatchMain" class="income-price-breakdown-dialog__match-note">
          — збігається
        </span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="mode === 'multi'">
    <div class="income-price-breakdown-dialog__blend" *ngIf="blend">
      <div class="income-price-breakdown-dialog__blend-row">
        Зі складу (за ФІФО-ціною {{blend.stockPrice | number:'1.2-2'}}):
        <strong>{{blend.coveredQty | number:'1.0-2'}}</strong> з {{blend.qty | number:'1.0-2'}}
      </div>
      <div class="income-price-breakdown-dialog__blend-row" *ngIf="blend.excessQty > 0">
        Понад залишок (за резервною ціною {{blend.fallbackPrice | number:'1.2-2'}}):
        <strong>{{blend.excessQty | number:'1.0-2'}}</strong>
      </div>
      <div class="income-price-breakdown-dialog__blend-row income-price-breakdown-dialog__totals">
        Розрахована ціна (основна валюта):
        <strong [class.income-price-breakdown-dialog__mismatch]="isMismatchBlend">{{blendComputedPrice | number:'1.2-2'}}</strong>
      </div>
      <div class="income-price-breakdown-dialog__compare" *ngIf="cellPriceMain !== null">
        Ціна в документі (основна валюта): <strong>{{cellPriceMain | number:'1.2-2'}}</strong>
        <span *ngIf="isMismatchBlend" class="income-price-breakdown-dialog__mismatch-note">
          — не збігається з розрахованою вище
        </span>
        <span *ngIf="!isMismatchBlend" class="income-price-breakdown-dialog__match-note">
          — збігається
        </span>
      </div>
    </div>

    <hr class="income-price-breakdown-dialog__divider" />

    <div *ngFor="let depot of depotBreakdowns" class="income-price-breakdown-dialog__depot">
      <h4>{{depot.label}}<ng-container *ngIf="depot.stock !== null"> — залишок {{depot.stock | number:'1.0-2'}}, ціна {{depot.price | number:'1.2-2'}}</ng-container></h4>

      <p-progressSpinner *ngIf="depot.loading" styleClass="income-price-breakdown-dialog__spinner" strokeWidth="6"></p-progressSpinner>

      <div *ngIf="!depot.loading && depot.error" class="income-price-breakdown-dialog__error">
        Не вдалося завантажити структуру ціни для цього складу.
      </div>

      <div *ngIf="!depot.loading && !depot.error && depot.rows.length === 0" class="income-price-breakdown-dialog__empty">
        Немає історії надходжень на цьому складі.
      </div>

      <div *ngIf="!depot.loading && !depot.error && depot.rows.length === 1 && depot.rows[0].IsFallback" class="income-price-breakdown-dialog__fallback">
        На складі немає партій, що відповідають цій даті — використано ціну останнього надходження.
      </div>

      <p-table *ngIf="!depot.loading && !depot.error && depot.rows.length > 0" [value]="depot.rows" styleClass="p-datatable-gridlines p-datatable-striped">
        <ng-template pTemplate="header">
          <tr>
            <th>Документ</th>
            <th>Дата</th>
            <th style="text-align: right">Кількість</th>
            <th style="text-align: right">Ціна (валюта документа)</th>
            <th style="text-align: right">Сума (валюта документа)</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{row.DOCNUMBER}}</td>
            <td>{{row.DOCDATE | date:'dd.MM.yyyy'}}</td>
            <td style="text-align: right">{{row.UnitsFromBatch | number:'1.0-2'}}</td>
            <td style="text-align: right">{{row.ConvertedPrice | number:'1.2-2'}}</td>
            <td style="text-align: right">{{row.LineValue | number:'1.2-2'}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </ng-container>

  <ng-template pTemplate="footer">
    <p-button label="Закрити" [text]="true" severity="primary" (onClick)="onHide()"></p-button>
  </ng-template>
</p-dialog>
